// Utils
import useVisible from '../../hooks/useVisibile';

// Context
import { HelpSupport } from './HelpSupport';

type HeaderHelpSupportProps = {};

export const HeaderHelpSupport = (props: HeaderHelpSupportProps) => {
  const { ref, isComponentVisible, setIsComponentVisible } = useVisible(false);

  const handleShow = (event: any) => {
    event.preventDefault();
    setIsComponentVisible(!isComponentVisible);
  };

  return (
    <div ref={ref} className={isComponentVisible ? 'icon-circle-query-open' : 'icon-circle-query'}>
      <a
        href='/'
        onClick={handleShow}
        className='col-auto p-3'
        style={{ top: '7.5px', textDecoration: 0, color: isComponentVisible ? 'white' : 'rgb(40, 50, 68)' }}
      >
        Raise a query
      </a>

      <HelpSupport
        isComponentVisible={isComponentVisible}
        handleClose={() => setIsComponentVisible(false)}
      ></HelpSupport>
    </div>
  );
};
